export let AFFINITY_CALCULATION_STRATEGY = /*#__PURE__*/function (AFFINITY_CALCULATION_STRATEGY) {
  AFFINITY_CALCULATION_STRATEGY[AFFINITY_CALCULATION_STRATEGY["WHOLE_STRING"] = 0] = "WHOLE_STRING";
  AFFINITY_CALCULATION_STRATEGY[AFFINITY_CALCULATION_STRATEGY["PREFIX"] = 1] = "PREFIX";
  AFFINITY_CALCULATION_STRATEGY[AFFINITY_CALCULATION_STRATEGY["CAPACITY"] = 2] = "CAPACITY";
  AFFINITY_CALCULATION_STRATEGY[AFFINITY_CALCULATION_STRATEGY["EXTRACTED_VALUE_CAPACITY"] = 3] = "EXTRACTED_VALUE_CAPACITY";
  return AFFINITY_CALCULATION_STRATEGY;
}({});
//# sourceMappingURL=enums.js.map